<div class="no-search-result" data-testing-id="no-search-result-page">
  <div class="marketing-area">
    <ish-content-include includeId="include.searchnoresult.base.top.pagelet2-Include" />
  </div>

  <ish-breadcrumb />

  <h1 class="h2">{{ 'search.noResult.heading' | translate }}</h1>

  <div class="marketing-area">
    <ish-content-include includeId="include.searchnoresult.content.top.pagelet2-Include" />
  </div>

  <p class="no-search-result-title" [innerHTML]="'search.noResult.message' | translate : { '0': searchTerm() }"></p>

  <div class="search-container main-search-container">
    <ng-container *ishNotFeature="'sparqueSearch'">
      <custom-search-box
        [configuration]="{
          placeholder: 'search.searchbox.instructional_text' | translate,
          autoSuggest: true,
          maxAutoSuggests: 10
        }"
      />
    </ng-container>
    <div *ishFeature="'sparqueSearch'">
      <ish-search-box
        [configuration]="{
          placeholder: 'search.searchbox.instructional_text' | translate,
          maxAutoSuggests: 10
        }"
      />
    </div>
  </div>

  <div class="search-guidelines" [innerHTML]="'search.noresult.guidelines' | translate"></div>

  <div class="marketing-area">
    <ish-content-include includeId="include.searchnoresult.content.bottom.pagelet2-Include" />
  </div>

  <div class="marketing-area">
    <ish-content-include includeId="include.searchnoresult.base.bottom.pagelet2-Include" />
  </div>
</div>
